import classNames from 'classnames';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';

import { Typography } from '@/shared/components/atoms';

const GeneralTabSection: React.FC<{
  children: React.ReactNode;
  title: string;
  description?: string;
  width?: 'full' | 'half';
}> = ({ children, title, description, width = 'full' }) => {
  const {
    i18n: { dir },
  } = useTranslation();

  return (
    <div
      className={clsx(
        'grid w-full grid-cols-10 border-b-xs border-neutralVariant-90 py-48',
        width === 'full' && ' last-of-type:border-b-0'
      )}
    >
      <div
        className={clsx(width === 'full' ? 'col-span-3 mt-16' : 'col-span-7')}
      >
        <Typography variant='subtitle' weight='semiBold'>
          {title}
        </Typography>
        {description && (
          <Typography
            variant='subtitle2'
            className={classNames(
              'mt-4 text-surface-10 desktop:max-w-[80%]',
              dir() === 'ltr' ? 'pr-16' : 'pl-16'
            )}
          >
            {description}
          </Typography>
        )}
      </div>
      <div
        className={clsx(
          width === 'full' ? 'col-span-7' : 'col-span-3 flex items-center'
        )}
      >
        {children}
      </div>
    </div>
  );
};

export { GeneralTabSection };
